export default __webpack_public_path__ + "static/media/res5.974366fd.PNG";